import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import params from '../config/Params';
import { getItemFromLocalStorage } from '../utils/storageUtils';
import { toast } from 'react-toastify';
import StarButton from './StarButton';
import Loader from './Loader';

const ListingStep19 = ({ formData, handleChange, prevStep, onRegisterSave }) => {
  const { listingId } = formData;
  const navigate = useNavigate();
  const [listingData, setListingData] = useState([]);
  const [paymentOptionList, setPaymentOptionList] = useState([]);
  const [paymentOption, setPaymentOption] = useState(2);
  const [question, setQuestion] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [loading, setLoading] = useState(true);
  const [securityDeposit, setSecurityDeposit] = useState('')
  const [cleaningFee, setCleaningFee] = useState('')
  const [cleaningFeeShort, setCleaningFeeShort] = useState('')
  const [petFee, setPetFee] = useState('')
  const [extraGuestFee, setExtraGuestFee] = useState('')
  const [guestAllowed, setGuestAllowed] = useState(1)
  const [feeType,setFeeType] = useState('')


  useEffect(() => {
    const fetchListingData = async () => {
      const hostData = getItemFromLocalStorage('hostProfile');
      let formData = new FormData();
      formData.append('token', hostData.host_access_token);
      formData.append('listing_id', listingId);

      try {
        const response = await axios({
          method: 'post',
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          url: `${params.baseURL}${params.endpoints.getListingData}`,
          data: formData,
        });

        if (response.data.status === 'ok') {
          const listingData = response.data.updated_property_item;
          const { appr_list, resrv_list, offers, place_options_list } = listingData;
          setListingData(response.data.updated_property_item);
          setPaymentOption(listingData.payment_option !== null ? listingData.payment_option : 2);
          setQuestion(response.data.updated_property_item.questions);
          setSecurityDeposit(listingData?.security_deposit)
          setCleaningFee(listingData?.cleaning_fee)
          setCleaningFeeShort(listingData?.cleaning_fee_ss)
          setPetFee(listingData?.pet_fee)
          setFeeType(listingData?.pet_fee_unit)
          setExtraGuestFee(listingData?.extra_guest_fee)
          setGuestAllowed(listingData?.extra_guest_fee_after_guests ?? 1)

          setLoading(false);
        } else {
          toast.error('An error occurred while fetching data.');
          setLoading(false);
        }
      } catch (err) {
        console.error(err.message);
        toast.error('Failed to load listing data.');
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };

    const fetchHotelData = async () => {
      const hostData = getItemFromLocalStorage('hostProfile');
      let formData = new FormData();
      formData.append('token', hostData.host_access_token);
      formData.append('listing_id', listingId);

      try {
        const response = await axios({
          method: 'post',
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          url: `${params.baseURL}${params.endpoints.hotelDataList}`,
          data: formData,
        });

        if (response.data.status === 'ok') {
          const dataList = response.data.list;
          const paymentOptionData = dataList.find(item => item.payment_options)?.payment_options || [];
          setPaymentOptionList(paymentOptionData);
        } else {
          toast.error('An error occurred while fetching data.');
        }
      } catch (err) {
        console.log(err.message);
      }
    };

    fetchListingData();
    fetchHotelData();
  }, [listingId]);

  
    const saveListing = async () => {
      const hostData = getItemFromLocalStorage('hostProfile');
      const ts = Date.now();

      const updatedPropertyItem = {
        payment_option: paymentOption,
        security_deposit: securityDeposit || 0,
        cleaning_fee: cleaningFee || 0,
        cleaning_fee_ss: cleaningFeeShort || 0,
        pet_fee: petFee || 0,
        pet_fee_unit: feeType,
        extra_guest_fee: extraGuestFee || 0,
        extra_guest_fee_after_guests: guestAllowed
      };

      const mergedData = { ...listingData, ...updatedPropertyItem };

      let catData = new FormData();
      catData.append('token', hostData.host_access_token);
      catData.append('listing_id', listingId);
      catData.append('data', JSON.stringify(mergedData));
      catData.append('ts', ts);

      try {
        const response = await axios({
          method: 'post',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          url: `${params.baseURL}${params.endpoints.updateListing}`,
          data: catData,
        });

        if (response.data.status === 'done') {
          navigate('/my-listings');
          setTimeout(() => {
            toast.success("Listing updated successfully!");
          }, 300);

          return true;
        } else {
          toast.error('Failed to save data');
          return false;
        }
      } catch (err) {
        toast.error('An error occurred while saving the listing');
        return false;
      }
    };

    

  const handleIncrement = (value, setter, max = 10) => {
    if (value < max) {
      setter(value + 1);
    }
  };

  const handleDecrement = (value, setter, min = 1) => {
    if (value > min) {
      setter(value - 1);
    }
  };

  const faqs = [
    {
      question: "What is Lorem Ipsum?",
      answer: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
    },
    {
      question: "Where does it come from?",
      answer: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old."
    },
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  if (loading) {
    return (
      <Loader />
    );
  }

  return (
    <div className="fade-in">
      <button id='host-listing-trigger-20' style={{ display: 'none' }} onClick={() => {
        if (onRegisterSave) {
          onRegisterSave(saveListing);
        }
      }}>Done</button>

      <div className='row'>
        {/*<div className='col-md-4 listing-img-box'>
          <div className='lsib'>
            <img src={'/assets/img/listing/listing_side_img.gif'} alt="Listing Image" className="listing-image" />
            {question && (
              <div className='lsqa-btn'>
                <StarButton text="Guide" link={question.find((q) => q.id === 19)?.link || '#'} />
              </div>
            )}
          </div>
        </div>*/}

        <div className='col-md-7'>

          <div className='ws-cl-header'>
            <div>
              <h4 className='ws-title'>Fees</h4>
              <p className='ws-desc'>Additional fees like security deposits & cleaning fees.</p>
            </div>
          </div>

          <div className='st1-desc-box'>
            <div className='ws-row'>
              <div className='col-md-12'>
                <p className='fee-box-title'><strong>Security Deposit</strong></p>
              </div>
              <div className='col-md-12'>
                <div className="room-detail-box">
                  <div>
                    <p className="rdb-title mb-0">Per stay</p>
                  </div>
                  <div className="fee-input-box">
                    <img src='/assets/img/icons/rupee-currency.svg' className='fee-rupee-icon img-fluid' alt='₹' />
                    <input type='text' className='form-control fee-input-field' name='perStay' placeholder='0' value={securityDeposit} onChange={e => setSecurityDeposit(e.target.value)} style={{ border: 'none' }} />
                  </div>
                </div>
              </div>
            </div>

            <hr style={{ borderTop: '5px solid', marginTop: '1.5rem' }} />

            <div className='ws-row'>
              <div className='col-md-12'>
                <p className='fee-box-title'><strong>Cleaning fee</strong></p>
              </div>
              <div className='col-md-12'>
                <div className="room-detail-box">
                  <div>
                    <p className="rdb-title mb-0">Per stay</p>
                  </div>
                  <div className="fee-input-box">
                    <img src='/assets/img/icons/rupee-currency.svg' className='fee-rupee-icon img-fluid' alt='₹' />
                    <input type='text' className='form-control fee-input-field' placeholder='0' name='perStay' value={cleaningFee} onChange={e => setCleaningFee(e.target.value)} style={{ border: 'none' }} />
                  </div>
                </div>
              </div>
              <div className='col-md-12'>
                <div className="room-detail-box">
                  <div>
                    <p className="rdb-title mb-0">Per short stay</p>
                  </div>
                  <div className="fee-input-box">
                    <img src='/assets/img/icons/rupee-currency.svg' className='fee-rupee-icon img-fluid' alt='₹' />
                    <input type='text' className='form-control fee-input-field' name='perStay' value={cleaningFeeShort} onChange={e => setCleaningFeeShort(e.target.value)} placeholder='0' style={{ border: 'none' }} />
                  </div>
                </div>
              </div>
            </div>

            <hr style={{ borderTop: '5px solid', marginTop: '1.5rem' }} />

            <div className='ws-row'>
              <div className='col-md-12'>
                <p className='fee-box-title'><strong>Pet fee</strong></p>
              </div>
              <div className='row p-0 m-0'>
                <div className='col-md-6 ps-0 ml-0'>
                  <div className="room-detail-box">
                    <div>
                      <p className="rdb-title mb-0">Fee Type</p>
                    </div>
                    <div className="fee-input-box" style={{ marginBottom: 13 }}>
                      <select className='form-control' value={feeType} onChange={e=>setFeeType(e.target.value)}>
                        <option value="">Select Option</option>
                        {listingData?.pet_fee_types?.length > 0 && listingData?.pet_fee_types?.map((item) => (
                          <option value={item?.id} key={item?.id}>{item?.title}</option>
                        ))}

                      </select>
                    </div>
                  </div>
                </div>
                <div className='col-md-6 pe-0'>
                  <div className="room-detail-box">
                    <div>
                      <p className="rdb-title mb-0">{feeType ? listingData?.pet_fee_types?.filter(item => item?.id == feeType)[0]?.title : 'Per pet'}</p>
                    </div>
                    <div className="fee-input-box">
                      <img src='/assets/img/icons/rupee-currency.svg' className='fee-rupee-icon img-fluid' alt='₹' />
                      <input type='text' className='form-control fee-input-field' name='perStay' value={petFee} onChange={e => setPetFee(e.target.value)} placeholder='0' style={{ border: 'none' }} />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <hr style={{ borderTop: '5px solid', marginTop: '1.5rem' }} />

            <div className='ws-row'>
              <div className='col-md-12'>
                <p className='fee-box-title'><strong>Extra guest fee</strong></p>
              </div>
              <div className='row'>
                <div className='col-md-6 ps-0 ml-0'>
                  <div className="room-detail-box">
                    <div>
                      <p className="rdb-title mb-0">Extra Guest</p>
                    </div>
                    <div className='house-rules-box' style={{ borderBottom: 0,paddingBottom : 0 }}>
                      <div className='rules-guest-box'>
                        <div className="input-number-container">
                          <span className="input-number-decrement" onClick={() => handleDecrement(guestAllowed, setGuestAllowed)}>–</span>
                          <input
                            name='guest'
                            className="input-number"
                            type="number"
                            value={guestAllowed}
                            readOnly
                          />
                          <span className="input-number-increment" onClick={() => handleIncrement(guestAllowed, setGuestAllowed)}>+</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='col-md-6 pe-0'>
                  <div className="room-detail-box">
                    <div>
                      <p className="rdb-title mb-0">After {guestAllowed} guest fee</p>
                    </div>
                    <div className="fee-input-box">
                      <img src='/assets/img/icons/rupee-currency.svg' className='fee-rupee-icon img-fluid' alt='₹' />
                      <input type='text' className='form-control fee-input-field' placeholder='0' name='perStay' value={extraGuestFee} onChange={e => setExtraGuestFee(e.target.value)} style={{ border: 'none' }} />
                    </div>
                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>
        <div className='col-md-1'></div>
        <div className='col-md-4 p-0'>
          <div className='bfhsd'>
            <div className='blog-box'>
              <div class="blog">
                <div class="blog-image">
                  <img src={'https://app.wirestay.com/ws/uploads/blog/1736870810_pi.jpg'} className='img-fluid' alt="" />
                  <div class="date">May 08, 2025</div>
                </div>
                <div class="blog-content">
                  <h2>What is Lorem Ipsum?</h2>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris vel metus vel est fermentum consectetur.</p>
                  <a href="#">Read More</a>
                </div>
              </div>
            </div>
            <div className="faq-sticky">
              {faqs.map((faq, index) => (
                <div key={index} className='faqs-list-section'>
                  <div
                    onClick={() => toggleAccordion(index)} className='faqs-qustn-box'
                    style={{
                      backgroundColor: activeIndex === index ? "#f7f7f7" : "#ffffff",
                    }}
                  >
                    {faq.question}
                    <i
                      className={`fas ${activeIndex === index ? "fa-chevron-up" : "fa-chevron-down"
                        }`}
                      style={{
                        transition: "transform 0.3s ease",
                      }}
                    ></i>
                  </div>
                  {activeIndex === index && (
                    <div className='faqs-ans-box'>
                      {faq.answer}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default ListingStep19;